import {getPrivateAxios, Plan} from '@blesk-frontend/api';

export const fetchBillingPlans = async () => {
  const {data} = await getPrivateAxios().get<Plan[]>('/billing/plans');
  return data;
};
